const integrations = [
    {
        path: '/integrations',
        name: 'integrations',
        component: () => import('@/views/integrations/IntegrationHome.vue'),
        meta: {
            env:['production'],
            pageTitle: "Integrações entre eLoja e ERP's",
            roles: [5],
        },
    },


]

export default integrations
